<template>
  <div>
    <div class='text-center' v-if='loadingEngage'>
      <i class='fa fa-spinner fa-pulse'></i>
    </div>
    <ul class="list-group list-group-flush">
      <!-- <li class="list-group-item">
        <h6 class="mb-0"> SIGNALS: &nbsp;
          <img class="mr-2" src="static/assets/img/icon-signal1.png" />
          <img class="mr-2" src="static/assets/img/icon-signal2.png" />
          <img class="mr-2" src="static/assets/img/icon-signal3.png" />
          <img class="mr-2" src="static/assets/img/icon-signal4.png" />
          <img class="mr-2" src="static/assets/img/icon-signal5.png" />
          <img class="mr-2" src="static/assets/img/icon-signal6.png" />
          <img class="mr-2" src="static/assets/img/icon-signal7.png" />
        </h6>
      </li> -->
      <!-- public string SignalType { get; set; }
           public string PageTitle { get; set; }
           public string Page { get; set; }
           public string PageURL { get; set; }
           public DateTime Date { get; set; }
       -->
      <li class="list-group-item py-4" v-for='(signal,index) in sortedSignals' :key='index'>
        <im-open :signal='signal' v-if='signal.SignalType == "IMOPEN"'></im-open>
        <im-purl :signal='signal' v-else-if='signal.SignalType == "IMPURL"'></im-purl>
        <im-click :signal='signal' v-else-if='signal.SignalType == "IMCLICK"'></im-click>
        <purl-lead :signal='signal' v-else-if='signal.SignalType == "IMLEAD"'></purl-lead>
        <generic-signal :signal='signal' v-else></generic-signal>
      </li>
      <li v-if='hasMoreEngage'>
        <div style='text-align: center' class='pt-1 pb-1'>
        <button  @click='loadMoreSignals()' class='btn btn-primary'>{{loadingMore ? 'Loading' : 'Load more'}}</button>
        </div>
      </li>

    </ul>
    <div v-if='signals.length == 0 & !loadingEngage' class='pt-3 content'>
      There is currently no Engagement data available.
    </div>
  </div>
</template>

<script>
  import {
    CustomerAPIClient
  } from '@/lib/data_access/Customer'
  import ImOpen from '@/components/CustomerProfile/Signals/SignallTypes/ImOpen'
  import ImPurl from '@/components/CustomerProfile/Signals/SignallTypes/ImPurl'
  import PurlLead from '@/components/CustomerProfile/Signals/SignallTypes/PurlLead'
  import ImClick from '@/components/CustomerProfile/Signals/SignallTypes/ImClick'
  import GenericSignal from '@/components/CustomerProfile/Signals/SignallTypes/GenericSignal'

  import moment from 'moment'
  export default {
    name: 'customerSignals',
    data: function () {
      return {
        signals: [],
        loadingEngage: true,
        start: 0,
        size: 25,
        hasMoreEngage: true,
        loadingMore: false
      }
    },
    components: {
      ImOpen,
      ImPurl,
      PurlLead,
      GenericSignal,
      ImClick,
    },
    methods: {
      loadMoreSignals() {
        let vm = this;
        vm.loadingMore = true;
        let custIds = vm.$parent.assosciatedIds
        custIds.start = vm.start;
        custIds.size = vm.size;
        CustomerAPIClient.getCustomerEngagement(custIds).then(function (customerEngagement) {
          if (customerEngagement) {
            vm.signals = Object.assign([], vm.signals.concat(customerEngagement));
            if (customerEngagement.length == vm.size) {
              vm.hasMoreEngage = true
              vm.start = vm.start + vm.size;
            } else {
              vm.hasMoreEngage = false
            }
            vm.loadingMore = false
          }
        })
      }
    },
    created() {
      let vm = this;
      vm.loadingEngage = true;
      let custIds = vm.$parent.assosciatedIds
      custIds.start = vm.start;
      custIds.size = vm.size;
      CustomerAPIClient.getCustomerEngagement(custIds).then(function (customerEngagement) {
        if (customerEngagement) {
          vm.signals = Object.assign([], customerEngagement);
          if (customerEngagement.length == vm.size) {
            vm.hasMoreEngage = true
            vm.start = vm.start + vm.size;
          } else {
            vm.hasMoreEngage = false
          }
          vm.loadingEngage = false
        }
      })
    },
    computed: {
      sortedSignals: function () {
        let vm = this;

        if (vm.signals.length > 0) {
          let rtnArray = vm.signals.sort(function (right, left) {
            return moment.utc(left.Date).diff(moment.utc(right.Date))
          });

          console.log(rtnArray)
          return rtnArray
        } else {
          return []
        }
      }
    },
    filters: {
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      }
    }
  }

</script>

<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/Signals/CustomerSignals.vue